import { handleService } from './common'

export default {
  GetScreenTable (data) {
    let url = '/api/Device/GetScreenEquListByPgae'
    // debugger
    return handleService(url, data)
  },

  // 故障状态查询
  GetStatus (data) {
    console.log(data)
  }
}
